import { NextPage } from 'next';

import { injectAppContextGetServerSideProps } from '../../../../_app';
import {
  fetchMerchantDetail,
  fetchProductDetail,
} from '../../../../../infrastructure/api';

import { buildSiteUrl } from 'src/utils/request-url';
import { PreparingMerchantSite } from 'src/molecules/PreparingMerchantSite';

interface Query {
  publicId: string;
  productId: string;
}

interface Props {
  isCoubicApp: boolean;
}

export const getServerSideProps = injectAppContextGetServerSideProps<Props>(
  async (context) => {
    const { query, session, token, requestId, isCoubicApp } = context;
    const { publicId, productId } = query as unknown as Query;

    const merchantDetailResponse = await fetchMerchantDetail({
      session,
      token,
      requestId,
      merchantPublicId: publicId,
      serverResponse: context.res,
    });
    if (merchantDetailResponse.redirect) {
      return { redirect: merchantDetailResponse.redirect };
    }
    const { merchant, isUnpublishedSite } = merchantDetailResponse;

    // 非公開かつ事業所情報がない場合は、redirectせずに準備中のUIを表示する
    // 事業所情報がある場合もエンドユーザーに対して準備中のUI表示すべきな気がするが、
    // 元々通常の画面を表示する実装になっていたので、それを踏襲しredirectして通常ページを表示する挙動にしている
    if (isUnpublishedSite && !merchant) {
      return {
        props: {
          isCoubicApp,
        },
      };
    }

    const productDetail = await fetchProductDetail({
      session,
      token,
      requestId,
      merchantPublicId: publicId,
      productPublicId: productId,
    });
    const isSubscription = productDetail.scheme === 0;

    return {
      redirect: {
        destination: buildSiteUrl(
          `/${
            isSubscription ? 'subscriptions' : 'ticket_books'
          }/${productId}/purchase`,
          'next',
        ),
        permanent: false,
      },
    };
  },
);

// このページは新reservation flow(GmoPgとPaymentIntent対応 `src/pages/[publicId]/subscriptions/[productPublicId]/purchase/index.tsx` or `src/pages/[publicId]/ticket_books/[productPublicId]/purchase/index.tsx`)に基本的には移行済みである
// ただし、準備中の場合のみこのページで表示している
// そのため、準備中の場合以外はgetServerSidePropsでredirectしており、このcomponentは描画されない
const MerchantProductPurchase: NextPage<Props> = ({ isCoubicApp }) => {
  return (
    <PreparingMerchantSite
      isCoubicApp={isCoubicApp}
      logoImage={null}
      merchantPublicId={null}
      displayName={null}
    />
  );
};
export default MerchantProductPurchase;
